<template>
  <popover-map :position="coordinates" positioning="bottom-left" id="sketch-identification">
    <template #popover>
      <div
        class="tw:bg-white tw:min-w-[200px] tw:rounded-r-full tw:rounded-tl-full tw:flexrow-1 tw:justify-between tw:items-center tw:p-1.5 tw:border tw:border-gray-100 tw:shadow-md tw:pointer-events-auto"
      >
        <div class="tw:flexrow-2 tw:items-center">
          <user-avatar :id="feature.authorId" :settings="{ size: 48 }" />
          <div class="tw:flexcol-0.5 tw:text-left">
            <span class="tw:text-xs tw:font-medium tw:text-font">
              {{ feature.authorName }}
            </span>
            <span class="tw:text-xxs tw:text-gray-400 tw:hover:[&_.full-date]:inline tw:hover:[&_.read-date]:hidden">
              <span class="read-date">
                {{ $dayjs(feature.created).fromNow() }}
              </span>
              <span class="full-date tw:hidden">
                {{ $dayjs(feature.created).format('L, LT') }}
              </span>
            </span>
          </div>
        </div>
        <div>
          <dots-menu :items="[{ name: 'delete' }]" @delete="isDeleteDialogVisible = true" />
        </div>
      </div>

      <!-- SKETCH DELETE DIALOG -->
      <main-dialog
        v-if="isDeleteDialogVisible !== null"
        :is-visible.sync="isDeleteDialogVisible"
        :title="$i18n.t('dialog.deleteSketch')"
        :body="$i18n.t('dialog.deleteSketchBody')"
        agree-text="dialog.agreeDelete"
        @agree="deleteSketch"
        :loading="isDeleteDialogLoading"
      />
    </template>
  </popover-map>
</template>

<script>
import PopoverMap from '@/components/PopoverMap';
import UserAvatar from '@/components/UserAvatar';
import DotsMenu from '@/components/DotsMenu';
import MainDialog from '@/components/MainDialog';

import { call, get } from 'vuex-pathify';

export default {
  name: 'SketchPopover',
  components: {
    PopoverMap,
    UserAvatar,
    DotsMenu,
    MainDialog,
  },
  props: {
    coordinates: {
      type: Array,
      required: true,
    },
    feature: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isDeleteDialogVisible: null,
    isDeleteDialogLoading: false,
  }),
  computed: {
    currentProjectId: get('layers/project.id'),
  },
  methods: {
    removeProjectSketch: call('sketch/removeProjectSketch'),
    async deleteSketch() {
      this.isDeleteDialogLoading = true;
      try {
        const r = await this.removeProjectSketch({
          projectId: this.currentProjectId,
          sketches: [this.feature.id],
        });
        this.$root.$emit('toggleSketchLayer', r);
        this.$emit('onRemoved');
        this.isDeleteDialogVisible = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.isDeleteDialogLoading = false;
      }
    },
  },
};
</script>
